import { lazy, Suspense } from 'react';

import { ListSkeleton, TextSkeleton } from '@/shared/components/skeletons';

/*
 * Components the module contributes to other pages (group tabs, profile tab, side panel), loaded on first use so the
 * editor and forms they need stay out of the main bundle.
 */
const MembersTabLazy = lazy(async () => ({ default: (await import('./components/MembersTab')).MembersTab }));
const AboutTabLazy = lazy(async () => ({ default: (await import('./components/AboutTab')).AboutTab }));
const UserGroupsTabLazy = lazy(async () => ({
  default: (await import('./components/UserGroupsTab')).UserGroupsTab,
}));
const GroupPanelLazy = lazy(async () => ({ default: (await import('./components/GroupPanel')).GroupPanel }));

export function MembersTabEntry({ groupId }: { groupId: string }) {
  return (
    <Suspense fallback={<ListSkeleton rows={6} />}>
      <MembersTabLazy groupId={groupId} />
    </Suspense>
  );
}

export function AboutTabEntry({ groupId }: { groupId: string }) {
  return (
    <Suspense fallback={<TextSkeleton lines={6} />}>
      <AboutTabLazy groupId={groupId} />
    </Suspense>
  );
}

export function UserGroupsTabEntry({ userId }: { userId: string }) {
  return (
    <Suspense fallback={<ListSkeleton rows={4} />}>
      <UserGroupsTabLazy userId={userId} />
    </Suspense>
  );
}

export function GroupPanelEntry({ id }: { id: string }) {
  return (
    <Suspense fallback={<TextSkeleton lines={6} className="p-6" />}>
      <GroupPanelLazy id={id} />
    </Suspense>
  );
}
